import { createContext, useContext } from "react";

export const HrDirectEditContext = createContext(null);

export const useHrDirectEditContext = () => useContext(HrDirectEditContext);
